import React, { Fragment, useState } from 'react';
import { Typography, useTheme } from '@mui/material';
import SectionWidgetInner from 'entities/section/ui/sectionWidget/sectionWidgetInner';
import SectionWidgetHeader from 'entities/section/ui/sectionWidget/sectionWidgetHeader';
import SectionWidgetFooter from 'entities/section/ui/sectionWidget/sectionWidgetFooter';
import SectionWidgetContainer from 'entities/section/ui/sectionWidget/sectionWidgetContainer';
import { useNavigate } from 'react-router-dom';
import { useSearchParamsUtils } from 'app/hooks/useSearchParamsUtils';
import { SectionModel } from 'entities/section/model/sectionModel';
import { useTranslation } from 'react-i18next';
import { useBooleanScreens } from 'shared/hooks/useBooleanScreens';
import SectionWidgetLink from './sectionWidgetLink';
import Divider from 'shared/lib/components/lilUi/divider';
import { map } from 'lodash-es';

export default function DefaultSectionWidget({
  section,
  onEdit,
}: {
  section: SectionModel;
  onEdit?: (id: string) => void;
}) {
  const { t } = useTranslation();
  const theme = useTheme();

  const navigate = useNavigate();
  const { getSectionSearchParams } = useSearchParamsUtils();
  const { isLessLaptop } = useBooleanScreens();

  const [isHover, setIsHover] = useState(false);

  return (
    <SectionWidgetContainer
      isHover={isHover}
      setIsHover={setIsHover}
      onClick={() => {
        navigate({
          pathname: '/explorer',
          search: getSectionSearchParams({
            sectionId: section.id,
          }),
        });
      }}
      key={section.data?.name}
    >
      <SectionWidgetInner
        slots={{
          header: (
            <SectionWidgetHeader
              image={section.data?.image_src}
              sectionName={section.data?.name}
              isHover={isHover}
              {...(onEdit && { onStartEdit: () => onEdit(section.id) })}
            ></SectionWidgetHeader>
          ),
          amount: (
            <SectionWidgetFooter>
              <Typography
                variant={isLessLaptop ? 'f12fixed' : 'f16fixed'}
                color={theme.palette.text.secondary}
                sx={{ marginRight: '12px' }}
              >
                {`${section.data?.files_amount} ${
                  t('file.filecount', {
                    count: section.data?.files_amount || 0,
                  }).split(' ')[1]
                }`}
              </Typography>
              {map(section.data?.links, (linkData) => (
                <Fragment key={linkData.src}>
                  <Divider
                    dividerHeight={isLessLaptop ? '16px' : '20px'}
                    dividerColor={
                      isHover
                        ? theme.palette.text.secondary
                        : theme.palette.custom.lightGrey
                    }
                  ></Divider>
                  <SectionWidgetLink
                    setIsHover={setIsHover}
                    linkData={linkData}
                    key={linkData.text}
                  ></SectionWidgetLink>
                </Fragment>
              ))}
            </SectionWidgetFooter>
          ),
        }}
      ></SectionWidgetInner>
    </SectionWidgetContainer>
  );
}
